'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = exports.MediaStreamTypes = exports.ENGINE_STATES = exports.VIDEO_EVENTS = exports.UI_EVENTS = exports.DefaultModules = exports.DefaultControls = exports.DefaultUIComponents = undefined;

var _vidi = require('vidi');

var _player = require('./player');

var _player2 = _interopRequireDefault(_player);

var _ui = require('./constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

var _video = require('./constants/events/video');

var _video2 = _interopRequireDefault(_video);

var _playbackEngine = require('./playback-engine/playback-engine');

var _defaultControls = require('./ui/controls/default-controls');

var _defaultControls2 = _interopRequireDefault(_defaultControls);

var _overlay = require('./ui/overlay/overlay.controler');

var _overlay2 = _interopRequireDefault(_overlay);

var _loader = require('./ui/loader/loader.controler');

var _loader2 = _interopRequireDefault(_loader);

var _screen = require('./ui/screen/screen.controler');

var _screen2 = _interopRequireDefault(_screen);

var _controls = require('./ui/controls/controls.controler');

var _controls2 = _interopRequireDefault(_controls);

var _anomalyBloodhound = require('./anomaly-bloodhound/anomaly-bloodhound');

var _anomalyBloodhound2 = _interopRequireDefault(_anomalyBloodhound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultUIComponents = {
  Screen: _screen2.default,
  Overlay: _overlay2.default,
  ControlBlock: _controls2.default,
  Loader: _loader2.default
};

var DefaultModules = {
  AnomalyBloodhound: _anomalyBloodhound2.default
};

exports.DefaultUIComponents = DefaultUIComponents;
exports.DefaultControls = _defaultControls2.default;
exports.DefaultModules = DefaultModules;
exports.UI_EVENTS = _ui2.default;
exports.VIDEO_EVENTS = _video2.default;
exports.ENGINE_STATES = _playbackEngine.STATES;
exports.MediaStreamTypes = _vidi.MediaStreamTypes;
exports.Player = _player2.default;
exports.default = {
  DefaultUIComponents: DefaultUIComponents,
  DefaultControls: _defaultControls2.default,
  DefaultModules: DefaultModules,
  UI_EVENTS: _ui2.default,
  VIDEO_EVENTS: _video2.default,
  ENGINE_STATES: _playbackEngine.STATES,
  MediaStreamTypes: _vidi.MediaStreamTypes,
  Player: _player2.default
};
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/index.js
// module id = 1223
// module chunks = 1 2 3